


import { i18n } from '@shared/i18n';
import _values from 'lodash/values';

class ManageEnum {
  static get values() {
    return {
      ADMIN: 'admin',
      PROPERTY: 'property',
      SUBPROPERTY: 'subproperty',
      PROGRAM: 'program',
      SUBPROGRAM: 'subprogram',
      PROPERTY_MANAGER: 'propertyManager',
      SUBPROPERTY_MANAGER: 'subpropertyManager',
    };
  }

  static labelOf(programId) {
    if (!this.values[programId]) {
      return programId;
    }

    return i18n(`enumerators.manageType.${programId}.label`);
  }

  static descriptionOf(programId) {
    if (!this.values[programId]) {
      return programId;
    }

    return i18n(`enumerators.manageType.${programId}.description`);
  }

  static get selectOptions() {
    return _values(this.values).map((value) => ({
      id: value,
      value: value,
      title: this.descriptionOf(value),
      label: this.labelOf(value),
    }));
  }
}

export default ManageEnum;